import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6baf7e6e"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getVexTableProps } from '@/config';
import { getMerchandiseBlacklistListBySupplierId, deleteMerchandiseBlacklistListBySupplierId } from '@/request';
import MerchandiseBlacklistChooseModal from './MerchandiseBlacklistChooseModal.vue';
export default {
  name: 'MerchandiseBlacklistModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      default: ''
    },
    dept: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const keyword = ref('');
    const showChooseModal = ref(false);

    function openChooseModal() {
      showChooseModal.value = true;
    }

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        keyword.value = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });

    function deleteBlacklist() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm('确定要从黑名单中移除所选业务员吗？').then(() => {
        deleteMerchandiseBlacklistListBySupplierId({
          ids: selectRows.map(i => i.merchandiseBlacklistId).join(','),
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('reload');
            emit('success');
          } else {
            ElMessage.error(data.msg);
          }
        });
      });
    }

    function handleChooseSuccess() {
      table.value.commitProxy('reload');
      emit('success');
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      pagerConfig: {
        pageSize: 5
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return row.merchandiseBlacklistId;
        }

      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '120px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        width: '100px',
        showOverflow: true
      }, {
        title: '联系电话',
        field: 'linkPhone',
        width: '120px',
        showOverflow: true
      }, {
        title: '业务员类型',
        field: 'salesmanType',
        width: '120px',
        showOverflow: true
      }, {
        title: '更新人',
        field: 'updateBy',
        width: '100px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createAt',
        width: '150px',
        showOverflow: true
      }, {
        title: '更新时间',
        field: 'updateAt',
        width: '150px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getMerchandiseBlacklistListBySupplierId({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId,
              structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id,
              prodNo: props.row.prodNo,
              keyword: keyword.value,
              __warn: true
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: "销售员黑名单",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          type: "info",
          "show-icon": "",
          closable: false,
          title: "指定业务员不可购买该商品（一级团队维度）",
          class: "blacklist-tip"
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "200px",
                "margin-right": "10px"
              },
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
              placeholder: "账号/联系人"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = $event => openChooseModal())
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = $event => deleteBlacklist())
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(MerchandiseBlacklistChooseModal, {
        modelValue: showChooseModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showChooseModal.value = $event),
        row: __props.row,
        dept: __props.dept,
        supplierId: __props.supplierId,
        onSuccess: handleChooseSuccess
      }, null, 8, ["modelValue", "row", "dept", "supplierId"])], 64);
    };
  }

};